import React, {Component} from 'react';
import ContentWrapper from '../Layout/ContentWrapper';
import {Button, Card, CardBody, Table, Input, FormGroup, Row, Col} from 'reactstrap';
import axios from 'axios';

class AdminTripsList extends Component {
    constructor(props) {
        super(props);
        this.state = {
            trips: [],
            drivers: [],
            driver_id: '',
            status: '',
            loading: true
        };
    }

    componentDidMount() {
        document.title = 'Trips | Greenhaven';
        this.loadTrips();
    }

    loadTrips = () => {
        const self = this;
        this.setState({loading: true});
        axios.get('/api/admin/trips', {
            params: {
                driver_id: this.state.driver_id || undefined,
                status: this.state.status || undefined
            }
        }).then(function (response) {
            const data = response.data || {};
            self.setState({
                trips: data.trips || [],
                drivers: data.drivers || [],
                loading: false
            });
        }).catch(function (error) {
            self.setState({loading: false});
            if (error && error.response && error.response.status === 401) {
                window.location = '/login';
                return;
            }
        });
    }

    handleDriverFilterChange = (e) => {
        this.setState({driver_id: e.target.value}, this.loadTrips);
    }

    handleStatusFilterChange = (e) => {
        this.setState({status: e.target.value}, this.loadTrips);
    }

    render() {
        return (
            <ContentWrapper>
                <div className="content-heading d-flex justify-content-between align-items-center">
                    <div>Trips</div>
                    <Button color="primary" size="sm" onClick={() => this.props.history.push('/trips/create')}>
                        New Trip
                    </Button>
                </div>
                <Card className={this.state.loading ? 'card card-default whirl traditional mx-0' : 'card card-default mx-0'}>
                    <CardBody>
                        <Row className="mb-3">
                            <Col sm="12" md="6">
                                <FormGroup>
                                    <label className="mb-0">Driver</label>
                                    <Input type="select" value={this.state.driver_id}
                                           onChange={this.handleDriverFilterChange}>
                                        <option value="">(all drivers)</option>
                                        {this.state.drivers.map((d) => (
                                            <option key={d.driver_id} value={d.driver_id}>
                                                {d.first_name} {d.last_name}
                                            </option>
                                        ))}
                                    </Input>
                                </FormGroup>
                            </Col>
                            <Col sm="12" md="6">
                                <FormGroup>
                                    <label className="mb-0">Status</label>
                                    <Input type="select" value={this.state.status}
                                           onChange={this.handleStatusFilterChange}>
                                        <option value="">(all statuses)</option>
                                        <option value="draft">Draft</option>
                                        <option value="complete">Complete</option>
                                        <option value="validated">Validated</option>
                                    </Input>
                                </FormGroup>
                            </Col>
                        </Row>

                        <div className="table-responsive">
                            <Table size="sm" responsive className="table-hover table-pointer">
                                <thead>
                                <tr>
                                    <th>Date</th>
                                    <th>Driver</th>
                                    <th>Truck</th>
                                    <th>Status</th>
                                    <th className="text-right">Distance (km)</th>
                                    <th className="text-right">Hours</th>
                                </tr>
                                </thead>
                                <tbody>
                                {this.state.trips.length === 0 && !this.state.loading && (
                                    <tr>
                                        <td colSpan="6" className="text-center text-muted">No trips found.</td>
                                    </tr>
                                )}
                                {this.state.trips.map((t) => (
                                    <tr key={t.trip_id} onClick={() => this.props.history.push('/trips/' + t.trip_id)}>
                                        <td>{(t.trip_date || '').toString().substr(0, 10)}</td>
                                        <td>{t.driver_name || ''}</td>
                                        <td>{t.vehicle_name || ''}</td>
                                        <td>{t.status}</td>
                                        <td className="text-right">{t.total_distance_km}</td>
                                        <td className="text-right">{t.total_hours}</td>
                                    </tr>
                                ))}
                                </tbody>
                            </Table>
                        </div>
                    </CardBody>
                </Card>
            </ContentWrapper>
        );
    }
}

export default AdminTripsList;
